<div
  (click)="selectSlide(slideData)"
  id="slide-tree-{{ slideData.id }}"
  class="card-body slide-img "
  [ngClass]="slideData.id === selectedSlideId ? 'selected-slide' : ''"
  [innerHTML]="
    useEditorSlide ? (editorService.slideDom.documentElement.outerHTML | safeHTML) : (slideData.content | safeHTML)
  "
></div>
